export default __webpack_public_path__ + "img/dpeLLUAx.d2e9a959.svg";